import { Button, Typography } from '@evocolabs/orkaui'
import {
  _gtmEventAddToCart,
  _gtmEventCheckout,
  gtmDataLayerPushEvents
} from '@/utils/gtmDataLayerUtils'
import { useEffect, useState } from 'react'

import AI40 from '@evocolabs/icons/lib/AI40'
import AccessoryPackage from '@/src/components/Product/OrkaTwo/AccessoryPackage'
import Affirm from '@/src/script/Affirm'
import AutoSwitch32 from '@evocolabs/icons/lib/AutoSwitch32'
import Bluetooth32 from '@evocolabs/icons/lib/Bluetooth32'
import { Box } from '@mui/material'
import ChargingCaseRemote32 from '@evocolabs/icons/lib/ChargingCaseRemote32'
import Image from 'next/image'
import PhoneConnect32 from '@evocolabs/icons/lib/PhoneConnect32'
import ProductTitle from './ProductTitle'
// import ShippingDelay32 from '@evocolabs/icons/lib/ShippingDelay32'
import ShippingFree40 from '@evocolabs/icons/lib/ShippingFree40'
import { selector as baseSelector } from '@/src/redux/store'
import insertScript from '@/src/utils/ScriptHelper'
import replaceBlueTooth from '@/src/utils/replaceBlueToothHelper'
import styles from './styles.module.scss'
import theme from '@/src/theme'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

const paymentData = {
  title: 'Supported payment types:'
}
const IconList = [
  'PayPal.svg',
  'ApplePay.svg',
  'GooglePay.svg',
  'Discover.svg',
  'DinersClubInternational.svg',
  'Visa Classic.svg',
  'Mastercard.svg',
  'Amex.svg',
  'Interac.svg'
]

const priceSkinData = {
  /**
   * affirm价格展示格式为实际金额+‘00’，因此实际金额为$1899
   */
  price: '189900',
  label: '4 interest-free payments of $75 with',
  payMethod: 'Klarna.',
  more: 'View More'
}

const featuresData = [
  { icon: AI40, label: 'AI Adaptive DeNoise' },
  { icon: AutoSwitch32, label: 'Automatic Scene Switching' },
  { icon: Bluetooth32, label: 'Bluetooth 5.3 Connectivity' },
  { icon: ChargingCaseRemote32, label: 'Charging Case Remote Control' },
  {
    icon: PhoneConnect32,
    label: 'In-App Hearing Screening & Remote Consultation'
  }
]

const ShippingData = {
  icon: ShippingFree40,
  title: 'Free Shipping',
  content: '3-7 Business Days'
}

// const ShippingDelayData = {
//   icon: ShippingDelay32,
//   title: 'Free Shipping',
//   content: 'Extended est. delivery time: current shipping estimate is 2-3 weeks.'
// }

const continueBtnText = 'Out of Stock'

const PayInformation = function () {
  return (
    <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }} mt="12px">
      {IconList.map((name) => (
        <Image
          width={40}
          height={28}
          key={name}
          alt="pay information"
          src={
            'https://d2mhexn86y1lr4.cloudfront.net/website/product/checkout/' +
            name
          }
        />
      ))}
    </Box>
  )
}

const Payment = function () {
  return (
    <Box mt="16px">
      <Typography variant="body4">{paymentData.title}</Typography>
      <PayInformation />
    </Box>
  )
}

const Features = function () {
  return (
    <Box
      bgcolor={{ xs: '#F3F3F3', dl: '#FFFFFF' }}
      borderRadius={{ xs: '12px', dl: '0' }}
      padding={{ xs: '24px 16px', dl: 0 }}
    >
      {featuresData.map((d) => (
        <Box
          key={d.label}
          display="flex"
          alignItems="center"
          sx={{ '& + &': { marginTop: '16px' } }}
        >
          <d.icon size={32} />
          <Typography
            variant="Body3"
            color="#26201F"
            ml="10px"
            dangerouslySetInnerHTML={{ __html: replaceBlueTooth(d.label) }}
          ></Typography>
        </Box>
      ))}
    </Box>
  )
}

const Shipping = function () {
  return (
    <Box className={styles.freeShippingContainer}>
      <ShippingData.icon size={40} />
      <Box display="flex" flexDirection="column" ml="10px">
        <Typography variant="t1" color={theme.palette.grey[800]} mb="4px">
          {ShippingData.title}
        </Typography>
        <Typography variant="body3" color="#4E4947">
          {ShippingData.content}
        </Typography>
      </Box>
    </Box>
  )
}

const ShippingDelay = function () {
  return (
    <Box className={styles.freeShippingDelayContainer}>
      <Typography
        variant="t1"
        color={theme.palette.grey[800]}
        mb="4px"
        mt="16px"
      >
        {ShippingData.title}
      </Typography>
      <Box className={styles.freeShippingDelayAlertContainer}>
        <ShippingData.icon />
        <Typography
          variant="body5"
          color={theme.palette.error[500]}
          fontWeight="600"
          ml="4px"
        >
          {ShippingData.content}
        </Typography>
      </Box>
    </Box>
  )
}

const getPath = (email = '') => {
  const payload = [
    {
      quantity: 1,
      product_id: process.env.NEXT_PUBLIC_GOODS_ID,
      email
    }
  ]
  const path = `/Checkout?bigcommerce=${encodeURIComponent(
    JSON.stringify(payload)
  )}`
  return path
}

const ProductParameter = function () {
  const userInfo = useSelector(baseSelector.selectUserInfo)
  const email = userInfo?.email
  const [path, setPath] = useState(getPath())
  const router = useRouter()
  const [pendingGotoCheckout, setPendingGotoCheckout] = useState(false)

  useEffect(() => {
    if (email) {
      setPath(getPath(email))
    }
  }, [email])

  useEffect(() => {
    insertScript({ id: 'affirm-script', content: Affirm, lazy: 'defer' })
    const pDom = document.querySelector('.affirm-as-low-as')
    if (pDom) {
      pDom.addEventListener('mousedown', () => {
        const aDom = pDom.querySelector('a.affirm-modal-trigger')
        if (aDom && !aDom.id) {
          aDom.id = 'productbuy_learn_more'
        }
      })
    }
  }, [])

  useEffect(() => {
    if (pendingGotoCheckout) {
      gtmDataLayerPushEvents(_gtmEventCheckout)
      gtmDataLayerPushEvents(_gtmEventAddToCart)
      router.replace(path)
    }
  }, [pendingGotoCheckout])

  const gotoCheckoutLoadingClick = async () => {
    return await new Promise((resolve) => {
      if (email) {
        setPendingGotoCheckout(true)
        setTimeout(resolve, 1000 * 60)
      } else {
        setTimeout(() => {
          setPendingGotoCheckout(true)
          setTimeout(resolve, 1000 * 60)
        }, 1000 * 5)
      }
    })
  }

  return (
    <Box>
      <Box
        sx={{ display: { xs: 'block', dl: 'block' } }}
        mb="24px"
        mt={{ xs: '40px', dl: '0' }}
      >
        <ProductTitle />
      </Box>
      <Typography
        variant="h4"
        color="#26201F"
        sx={{ fontSize: '32px', fontFamily: 'Open Sans' }}
      >
        ${priceSkinData.price.slice(0, priceSkinData.price.length - 2)}
      </Typography>
      <Box
        sx={{
          '> p': {
            color: '#26201F',
            fontSize: '18px',
            mt: '8px',
            '> a': {
              fontWeight: '600',
              color: '#4E4947',
              textDecoration: 'underline',
              fontSize: '16px'
            }
          }
        }}
      >
        <p
          className="affirm-as-low-as"
          data-page-type="product"
          data-amount={priceSkinData.price}
        ></p>
      </Box>
      <Box mt="32px" display={{ xs: 'none', dl: 'block' }}>
        <Features />
      </Box>
      <Box sx={{ marginTop: { xs: '40px', dl: 0 } }}>
        {/* <PayNowOrLater/> */}
      </Box>
      <Shipping />
      {/* <ShippingDelay /> */}
      <AccessoryPackage />
      <Box margin="32px 0 16px">
        <Button
          id="productbuy_continue"
          size="large"
          block
          sx={{ backgroundColor: '#415670' }}
          handleClick={gotoCheckoutLoadingClick}
          loadable
          disabled={true}
        >
          {continueBtnText}
        </Button>
      </Box>
      <Payment />
      <Box mt="32px" display={{ xs: 'block', dl: 'none' }}>
        <Features />
      </Box>
    </Box>
  )
}

export default ProductParameter
